import { z } from "zod";

export const contactValidation = z.object({
  name: z.string().min(1),
  company_number: z.string().nullable().optional(),
  emails: z
    .object({
      upsert: z
        .array(
          z.object({
            email: z.string().email(),
          }),
        )
        .optional(),
    })
    .optional(),
});
